import {buildFile, downloadFile} from '@/utilities/helpers'
import {httpDownloadExport} from '@/features/exports/http/exports.http'
import {ExportJob} from '@/features/exports/types'

const FILE_EXTENSIONS = ['xlsx', 'xls', 'csv', 'pdf', 'txt'] as const
type FileExtension = (typeof FILE_EXTENSIONS)[number]

const resolveExtension = (format: string): FileExtension =>
    (FILE_EXTENSIONS as readonly string[]).includes(format) ? (format as FileExtension) : 'xlsx'

/**
 * Download a ready export job's file.
 * Prefers the signed `downloadUrl` when present; otherwise streams the blob from
 * `GET /v1/exports/:id/download`. Throws on failure so callers can surface the error.
 */
export const downloadExportJob = async (job: ExportJob): Promise<void> => {
    if (job.downloadUrl) {
        const link = document.createElement('a')
        link.href = job.downloadUrl
        link.target = '_blank'
        link.rel = 'noopener'
        if (job.fileName) link.download = job.fileName
        link.click()
        return
    }

    const response = await httpDownloadExport(job.id)
    const baseName = job.fileName?.replace(/\.[^./\\]+$/, '') || `export-${job.id}`
    downloadFile(buildFile({extension: resolveExtension(job.format), fileName: baseName, data: response.data}))
}
